import styles from "./BreadCrumb.module.scss";
import classNames from "classnames/bind";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faHouse } from "@fortawesome/free-solid-svg-icons";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
const cx = classNames.bind(styles);
function BreadCrumb({ data, brand }) {
    const render = data;
    return (
        <>
            {render ? (
                <ul className={cx("bread_crumb")}>
                    <Tippy content="Trang chủ" placement="bottom">
                        <li>
                            {" "}
                            <NavLink className={cx("bread_crumb-link")} to="/">
                                <i>
                                    <FontAwesomeIcon icon={faHouse} />
                                </i>
                            </NavLink>{" "}
                        </li>
                    </Tippy>

                    <li>
                        <FontAwesomeIcon icon={faAngleRight} />
                    </li>
                    <li>
                        <NavLink
                            className={cx("bread_crumb-link")}
                            to={render.path || brand.path}
                        >
                            {render.brand}
                        </NavLink>
                    </li>
                    {brand && (
                        <>
                            <li>
                                <FontAwesomeIcon icon={faAngleRight} />
                            </li>
                            <li>
                                <NavLink
                                    className={cx("bread_crumb-link")}
                                    to={brand.path || brand.link}
                                >
                                    {render.name}
                                </NavLink>
                            </li>
                        </>
                    )}
                    <li>
                        <FontAwesomeIcon icon={faAngleRight} />
                    </li>
                </ul>
            ) : (
                <></>
            )}
        </>
    );
}

export default BreadCrumb;
